module.exports = __webpack_public_path__ + "static/media/footer.4653c58f.png";